export default "__VITE_ASSET__5ec516fd__"